import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=765780d1&scoped=true&"
import script from "./NoticeMessage.vue?vue&type=script&lang=js&"
export * from "./NoticeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765780d1",
  null
  
)

export default component.exports